import script from "./ReturnIpdBill.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnIpdBill.vue?vue&type=script&setup=true&lang=js"

import "./ReturnIpdBill.vue?vue&type=style&index=0&id=7d0148ae&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0148ae"]])

export default __exports__